import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Exercise } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ParagraphActions } from '../paragraph/paragraph.actions';
import { flatten } from '@lyceo/shared/util';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { PractiseBookPageActions } from '../practise/practise.actions';
import { ExerciseActions } from './exercise.actions';
import { mapParagraphToExercises } from './exercise.functions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const EXERCISE_FEATURE_KEY: string = 'exercise';

export interface ExerciseState extends EntityState<Exercise> {
  alfredCallState: CallState;
}

export const exerciseAdapter: EntityAdapter<Exercise> =
  createEntityAdapter<Exercise>();

export const initialExerciseState: ExerciseState =
  exerciseAdapter.getInitialState({
    alfredCallState: LoadingState.INIT,
  });

const reducer: ActionReducer<ExerciseState, Action> = createReducer(
  initialExerciseState,
  on(AuthActions.logoutSuccess, (): ExerciseState => initialExerciseState),
  on(
    ParagraphActions.getParagraphByIdsSuccess,
    (state, action): ExerciseState =>
      exerciseAdapter.upsertMany(
        flatten(
          action.paragraphs.map((paragraphDto) =>
            mapParagraphToExercises(paragraphDto),
          ),
        ),
        {
          ...state,
        },
      ),
  ),
  on(
    ParagraphActions.getParagraphByIdSuccess,
    (state, action): ExerciseState =>
      exerciseAdapter.upsertMany(mapParagraphToExercises(action.paragraph), {
        ...state,
      }),
  ),
  on(
    PractiseBookPageActions.exerciseClicked,
    PractiseBookPageActions.finalExamExerciseClicked,
    (state): ExerciseState => ({
      ...state,
      alfredCallState: LoadingState.LOADING,
    }),
  ),
  on(
    ExerciseActions.getParagraphSessionSuccess,
    ExerciseActions.getBookSessionSuccess,
    (state): ExerciseState => ({
      ...state,
      alfredCallState: LoadingState.LOADED,
    }),
  ),
  on(
    ExerciseActions.getParagraphSessionFailure,
    ExerciseActions.getBookSessionFailure,
    (state, { error }): ExerciseState => ({
      ...state,
      alfredCallState: { errorMsg: error.message },
    }),
  ),
);

export function exerciseReducer(
  state: ExerciseState | undefined,
  action: Action,
): ExerciseState {
  return reducer(state, action);
}
